export const style = {
  tabsContainer: {
    sx: {
      mt: '24px',
    },
  },
  errorTab: {
    sx: (isError: boolean) => {
      if (isError) {
        return {
          color: '#D14343',
          marginRight: '24px',
        };
      }
      
      return {
        color: 'unset',
        marginRight: '0px',
      };
    },
  },
} as const;
